{
    "actions": {
        "row": {
            "update_label": "Modify SIM",
            "historics_access": "SIM history",
            "update_plan": "Modify offer",
            "activate": "Activate",
            "terminate": "Terminate",
            "reactivate": "Reactivate",
            "suspend": "Suspend",
            "replace": "Replace SIM",
            "order_sim": "Order SIM",
            "add_to": {
                "title": "Add",
                "organization": "Add to organization",
                "client": "Add to client"
            },
            "activate_sim_cards": {
                "title": "Multiple activation",
                "organization": "My sim cards",
                "client": "Clients sim cards"
            },
            "assign": "Assign",
            "manage_assign": {
                "title": "Manage assign",
                "reassign": "Reassign",
                "unassign": "Unassign"
            }
        }
    },
    "filter": {
        "placeholder": {
            "legal_name": "Filter by organization name",
            "label": "Filter by label",
            "iccid": "Filter by SIM number",
            "units": "Units"
        },
        "label": {
            "quantity": "Offer",
            "plan": "Offer type"
        },
        "plan_types": {
            "ALL": "All",
            "Data Only": "Data Only",
            "WITHOUT_DATA_ONLY": "Without Data Only"
        },
        "badge": {
            "label": "Plan",
            "value": "{{value0}} $t(simCard:units.{{value1}}) $t(simCard:filter.plan_types.{{value2}})"
        }
    },
    "form": {
        "error": {
            "required": "Label is required",
            "max_length": "Label maximum length (100) exceeded"
        }
    },
    "keys": {
        "status": "Status",
        "legal_name": "Organization name",
        "label": "Label",
        "iccid": "SIM number",
        "data": "Package",
        "data_usage": "Month consumption",
        "created_at": "Added on",
        "updated_at": "Last update",
        "cancellation_date": "Cancelled on",
        "activation_date": "Activation",
        "activation_request_date": "Activation request",
        "cancellation_request_date": "Cancellation request",
        "first_comm_date": "First co.",
        "last_comm_date": "Last co.",
        "end_engagement_date": "End engagement",
        "dispatch_date": "Dispatched on",
        "suspension_date": "Suspended on",
        "apns": "APN",
        "mno_name": "Operator"
    },
    "modal": {
        "update_label": {
            "title": "Modify SIM label",
            "text": "Label",
            "success": "SIM card updated successfully!",
            "error": "An error occurred while updating SIM card"
        },
        "update_plan": {
            "title": "Update SIM plan",
            "steps": {
                "plan_selection": "Step {{step}} of {{maxStep}}: New plan selection",
                "confirmation": "Step {{step}} of {{maxStep}}: Confirmation"
            },
            "plan_selection": {
                "text_1": "It is possible to upgrade your SIM plans to a higher plan.",
                "text_2": "However, reduction of the flat rate is not permitted for contractual reasons.",
                "text_3": "If you choose to upgrade to a higher plan, the retroactive effect will be applied to the 1st day of the subscription month.",
                "select": "Offer :"
            },
            "confirmation": {
                "text_1": "Are you sure you want to modify this SIM with offer \"{{simCardPlan}}\" for organization {{organizationName}}?",
                "text_2": "For information, usually update time is about 1 hour, but it can go up to 2 days.",
                "text_3": "Be sure to anticipate your requests for modification."
            },
            "fetch_plans_error": "An error occurred while fetching SIM plans",
            "highest_plan_alert": "You already have the highest offer, so you won't be able to edit this field",
            "success": "Offer updated successfully!",
            "error": "An error occurred while updating SIM plans"
        },
        "activate": {
            "title": "Sim card activation",
            "steps": {
                "offer_selection": "Step {{step}} of {{maxStep}} : Offer selection",
                "confirmation": "Step {{step}} of {{maxStep}} : Activation confirmation"
            },
            "selection": {
                "label": "Plan :",
                "placeholder": "Select an offer"
            },
            "confirmation": {
                "text_1": "Are you sure you want to activate this SIM card with offer {{offer}}?",
                "text_2": "For information, usually activation time is about 1 hour, but it can go up to 2 days.",
                "text_3": "Be sure to anticipate your requests for activations."
            },
            "success": "SIM card successfully activated!",
            "error": "An error occurred while activating SIM card"
        },
        "terminate": {
            "title": "Confirmation of resiliation",
            "text": "Please confirm your resiliation request for this SIM card",
            "success": "SIM card successfully terminated!",
            "error": "An error occurred while terminating SIM card"
        },
        "suspend": {
            "title": "Confirmation of suspension",
            "text": "Please confirm your suspension request for this SIM card",
            "success": "SIM card successfully suspended!",
            "error": "An error occurred while suspending SIM card"
        },
        "reactivate": {
            "title": "Confirmation of reactivation",
            "text": "Please confirm your reactivation request for this SIM card",
            "success": "SIM card successfully reactivated!",
            "error": "An error occurred while reactivating SIM card"
        },
        "replace": {
            "title": "Sim card replacement",
            "steps": {
                "sim_selection": "Step {{step}} of {{maxStep}} : SIM selection",
                "confirmation": "Step {{step}} of {{maxStep}} : Confirmation"
            },
            "replacement": "The SIM card {{previousSim}} will be replaced by the SIM card {{nextSim}}.",
            "text_1": "Replacing this SIM card will not re-engage you for an additional 12 months.",
            "text_2": "You will continue to keep the same plan as well as the same telephone number linked to the old SIM card after activation of the new SIM card.",
            "success": "SIM card replaced successfully!",
            "error": "An error occurred while replacing SIM card"
        },
        "multiple_activation": {
            "title": "Multiple activation of my SIM cards",
            "provider": {
                "label": "Provider :"
            },
            "offer": {
                "label": "Offer :"
            },
            "confirmation": {
                "text_1": "Are you sure you want to activate these SIM cards with offer \"{{offer}}\"?",
                "text_2": "For information, usually activation time is about 2 hours.",
                "text_3": "Be sure to anticipate your requests for activations."
            },
            "partial_activation": {
                "text_1": "The activation of SIMs was partially done due to the presence of errors in the list. Below is the list of SIM numbers that could not be added :",
                "text_2": "You can retry the multi-SIM activation operation. If the error persists, please contact the support team."
            },
            "steps": {
                "provider_selection": "Step {{step}} of {{maxStep}} : SIM cards provider selection",
                "client_selection": "Step {{step}} of {{maxStep}} : Client selection",
                "sims_selection": "Step {{step}} of {{maxStep}} : SIM cards to be activated selection",
                "offer_selection": "Step {{step}} of {{maxStep}} : Offer selection",
                "confirmation": "Step {{step}} of {{maxStep}} : Confirmation"
            },
            "success": "SIM cards successfully activated!",
            "error": "An error occurred while activating SIM cards",
            "error_providers": "An error occurred while fetching providers"
        },
        "order_sim": {
            "title": "Order SIM cards",
            "details": "Order details",
            "address": "Delivery address",
            "my_address": "My address",
            "other_address": "An other address",
            "steps": {
                "details": "Step {{step}} of {{maxStep}}: Entry of order details",
                "confirmation": "Step {{step}} of {{maxStep}}: Confirmation of order"
            },
            "form": {
                "provider": "Provider :",
                "provider_placeholder": "Select a privider",
                "quantity": "Quantité :",
                "civility": "Civility :",
                "contact_name": "Contact name :",
                "contact_surname": "Contact surname :",
                "phone_number": "Phone number :",
                "company": "Company name :",
                "street": "Street :",
                "post_code": "Post code :",
                "city": "City :",
                "street_number": "Street number :",
                "address": "Address :",
                "additional_address": "Aditional address :",
                "borough_needed": "Specify a borough number (eg:"
            },
            "summary": {
                "title": "Résumé de la commande",
                "keys": {
                    "quantity": "Quantité :",
                    "civility": "Civility :",
                    "contact_name": "Contact name :",
                    "contact_surname": "Contact surname :",
                    "phone_number": "Phone number :",
                    "company": "Company name :",
                    "street": "Street :",
                    "post_code": "Post code :",
                    "city": "City :"
                }
            },
            "validation": {
                "text1": "Thank you for your order!",
                "text2": "For information, SIM deliveries can take up to 1 week.",
                "text3": "Be sure to anticipate your SIM commands."
            },
            "error": "An error occurred, please contact our technical support."
        },
        "add": {
            "title": "Add SIM cards",
            "steps": {
                "client_selection": "Step {{step}} of {{maxStep}}: Client selection",
                "add_sims": "Step {{step}} of {{maxStep}}: Add SIM cards",
                "order": "Step {{step}} of {{maxStep}}: Enter the Order ID",
                "confirmation": "Step {{step}} of {{maxStep}}: Confirmation"
            },
            "labels": {
                "provider": "Provider:",
                "sims": "SIM cards numbers:",
                "order": "Order ID:"
            },
            "placeholder": {
                "sims": "Enter the SIM numbers here...",
                "order": "Enter the Order ID here..."
            },
            "text": {
                "number": "Total SIM cards processed: {{simNumber}}",
                "exists": "The SIM {{simAlreadyAdded}} has already been added!",
                "invalid": "The SIM {{invalidSimNumber}} is invalid!",
                "confirmation": "The SIMs related to the Order ID n°{{orderId}} will be added to the portal. Do you want to continue?"
            },
            "success": "SIM cards added to the organization successfully!",
            "error": "An error occurred while adding SIM cards to the organization",
            "error_providers": "An error occurred while fetching providers"
        },
        "assign": {
            "title": "Assign SIM cards",
            "steps": {
                "client_selection": "Step {{step}} of {{maxStep}}: Client selection",
                "assign_sims": "Step {{step}} of {{maxStep}}: Enter the SIM numbers to assign"
            },
            "success": "SIM cards assigned to the client successfully!",
            "error": "An error occurred while assigning SIM cards"
        },
        "reassign": {
            "title": "Reassign SIM cards",
            "steps": {
                "action_selection": "Step {{step}} of {{maxStep}}: Entry type",
                "sims_selection": "Step {{step}} of {{maxStep}}: SIM cards",
                "client_selection": "Step {{step}} of {{maxStep}}: Client selection",
                "confirmation": "Step {{step}} of {{maxStep}}: Confirmation"
            },
            "labels": {
                "action": "Option :"
            },
            "text": {
                "confirmation": "Are you sure you want to reassign these SIM cards to the client {{clientName}}?"
            },
            "success": "SIM cards reassigned to the client successfully!",
            "error": "An error occurred while reassigning SIM cards"
        },
        "unassign": {
            "title": "Unassign SIM cards",
            "steps": {
                "action_selection": "Step {{step}} of {{maxStep}}: Entry type",
                "sims_selection": "Step {{step}} of {{maxStep}}: SIM cards",
                "confirmation": "Step {{step}} of {{maxStep}}: Confirmation"
            },
            "labels": {
                "action": "Method selection :"
            },
            "text": {
                "confirmation": "Are you sure you want to unassign these SIM cards from the client {{clientName}}?"
            },
            "success": "SIM cards unassigned from the client successfully!",
            "error": "An error occurred while unassigning SIM cards"
        },
        "custom_pay_multiple_activation": {
            "title": "Multiple activation",
            "steps": {
                "client_selection": "Step {{step}} of {{maxStep}} : Client selection",
                "sims_selection": "Step {{step}} of {{maxStep}} : SIMs selection",
                "offer_selection": "Step {{step}} of {{maxStep}} : Offer selection",
                "confirmation": "Step {{step}} of {{maxStep}} : Confirmation"
            },
            "labels": {
                "offer": "Offer :"
            },
            "text": {
                "confirmation": "Are you sure you want to activate {{simNumber}} SIM cards with the offer \"{{offer}}\"?"
            },
            "success": "SIM cards activated successfully!",
            "error": "An error occurred while activating SIM cards",
            "error_offers": "An error occurred while fetching offers"
        },
        "import": {
            "explanations": {
                "header": "It is possible to perform operations by uploading a file. The file is in CSV format and must contain the following 4 columns :",
                "operation": "The Operations column corresponds to the type of operation to be performed on the SIM. The possible value is \"ACTIVATION\" for an activation.",
                "iccid": "The ICCID column corresponds to the ICCID of the SIM starting with \"89\" on which the operation must take place.",
                "contract": "The Contract column corresponds to the contract to be subscribed for the SIM when an activation is performed. The possible values are :",
                "client": "The Client column allows you to assign the SIM when an activation is performed. It corresponds to the name of the organization, found in the Organizations menu.",
                "offers": {
                    "ing_2": "Ingenico 2MB",
                    "ing_5": "Ingenico 5MB",
                    "ing_10": "Ingenico 10MB",
                    "ing_50": "Ingenico 50MB",
                    "ing_100": "Ingenico 100MB"
                }
            },
            "confirmation": "This operation will activate {{activations}} SIMs and terminate {{terminations}} SIMs. Do you want to continue ?",
            "success": "Operations performed successfully!",
            "error": {
                "invalid_file": "This file is not compatible (.csv only)",
                "BAD_REQUEST": "An unknown error occurred",
                "OFFER_NOT_FOUND": "The specified client is unknown",
                "FORBIDDEN": "The provider is not compatible with this client",
                "RESULT_LENGTH_MISMATCH": "There are unknown SIMs in the file",
                "BAD_FORMAT": "Error in file format",
                "INTERNAL_SERVER_ERROR": "An unknown error occurred"
            }
        }
    },
    "tooltip": {
        "data_usage": "Total consumption in MB since the 1st of the current month"
    },
    "next_offer": {
        "pending": "A request to modify the offer is being processed ({{nextOffer}}).",
        "pending_no_display_name": "A request to modify the offer is being processed."
    },
    "next_iccid": {
        "pending": "A request to replace SIM card is being processed ({{simData}}).",
        "pending_no_display_name": "A request to modify the offer is being processed."
    },
    "select_options": {
        "sim": {
            "select": "SIM selection",
            "input": "SIM input"
        }
    },
    "sim_pools": {
        "keys": {
            "organization": "Organization",
            "tariff_data": "Package",
            "sim_provider": "Provider",
            "activated_sims": "Activated SIM",
            "monthly_consumption": "Month cons.",
            "total_data": "Total data",
            "consumption_percentage": "Cons. %"
        },
        "filter": {
            "placeholder": {
                "organization": "Filter by organization name",
                "provider": "Filter by provider name"
            }
        },
        "tooltip": {
            "sim_groups_tab": "List of SIM groups. A click on the \"View details\" button displays the details of a SIM group.",
            "activated_sims": "Number of SIMs that have been active at some point in the current month. This includes Active, Suspended and Terminated SIMs.",
            "monthly_consumption": "Total consumption since the 1st of the current month by all SIMs with the package indicated in the package column for the organization indicated in the organization column.",
            "total_data": "Sum of SIM card packages with the package indicated in the Package column for the organization indicated in the Organization column. The sum includes the packages of all cards that have been active at any time during the current month"
        }
    },
    "status": {
        "UNKNOWN": "Unknown",
        "INACTIVE": "Inactive",
        "PENDING_ACTIVATION": "Pending activation",
        "PREACTIVATED": "Preactivated",
        "ACTIVATED": "Activated",
        "PENDING_SUSPENSION": "Pending suspension",
        "SUSPENDED": "Suspended",
        "PENDING_TERMINATION": "Pending termination",
        "TERMINATED": "Terminated",
        "PENDING_REPLACE": "Pending replacement"
    },
    "units": {
        "MB": "MB",
        "GB": "GB",
        "MO": "MB",
        "GO": "GB"
    }
}